import React from "react";

function Timeline({ items = [], className = "" }) {
  const classes = ["ui-timeline", className].filter(Boolean).join(" ");

  return (
    <ul className={classes}>
      {items.map((item, index) => (
        <li className="ui-timeline__item" key={item.key || index}>
          <div className="ui-timeline__title">{item.title}</div>
          {item.time && <div className="ui-timeline__time">{item.time}</div>}
          {item.description && (
            <div className="ui-timeline__description">{item.description}</div>
          )}
        </li>
      ))}
    </ul>
  );
}

export default Timeline;
